<template>
    <BusinessIncidentForm
        :errors="errors"
        :business-incident="businessIncident"
        :business-incident-types="businessIncidentTypes"
        :customer="customer"
        @submit-form="submitForm"
        @solve-incident="solveIncident"
        @cancel="cancel"
        @add-contracts="addContracts"
        @add-invoices="addInvoices"
        @add-orders="addOrders"
        @add-tickets="addTickets"
    />
</template>

<script>
import BusinessIncidentForm from '~@/Components/Customers/BusinessIncidents/Form'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

export default {
    layout: [App, CustomerBase]
}
</script>

<script setup>
const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    customer: {
        type: Object,
        default: () => {
            return {}
        }
    },
    businessIncidentTypes: {
        type: Array,
        default: () => {
            return []
        }
    }
})

const businessIncident = ref({
    id: null,
    customer_id: props.customer.id,
    customer_request_id: null,
    incident_solution_id: null,
    incident_type_id: null,
    status: 'open'
})

function submitForm (form) {
    form.post(
        route('customers.customers.business-incidents.store', { customer: props.customer.id })
    )
}

function solveIncident (form) {
    // Incident does not exist yet. Marking the incident as solved is the same as saving the new incident with
    // the status solved.
    submitForm(form)
}

function cancel () {
    router.get(route('customers.customers.business-incidents.index', { customer: props.customer.id }))
}

function addContracts ({ incidentForm, contractsForm }) {
    incidentForm.post(
        route('customers.customers.business-incidents.store', { customer: props.customer.id }),
        {
            onSuccess: (response) => {
                contractsForm.post(
                    route(
                        'customers.customers.add-business-incident-contract',
                        { businessIncident: response.props.businessIncident.id }
                    )
                )
            }
        }
    )
}

function addInvoices ({ incidentForm, invoicesForm }) {
    incidentForm.post(
        route('customers.customers.business-incidents.store', { customer: props.customer.id }),
        {
            onSuccess: (response) => {
                invoicesForm.post(
                    route(
                        'customers.customers.add-business-incident-invoice',
                        { businessIncident: response.props.businessIncident.id }
                    )
                )
            }
        }
    )
}

function addOrders ({ incidentForm, ordersForm }) {
    incidentForm.post(
        route('customers.customers.business-incidents.store', { customer: props.customer.id }),
        {
            onSuccess: (response) => {
                ordersForm.post(
                    route(
                        'customers.customers.add-business-incident-order',
                        { businessIncident: response.props.businessIncident.id }
                    )
                )
            }
        }
    )
}

function addTickets ({ incidentForm, ticketsForm }) {
    incidentForm.post(
        route('customers.customers.business-incidents.store', { customer: props.customer.id }),
        {
            onSuccess: (response) => {
                ticketsForm.post(
                    route(
                        'customers.customers.add-business-incident-ticket',
                        { businessIncident: response.props.businessIncident.id }
                    )
                )
            }
        }
    )
}
</script>
